const config = {
  scheme: 'https',
  host: 'pdf.jotta.cloud',
}

// config for qa and local testing. remember to restart dev server to get updated csp
// const config = {
//   scheme: 'https',
//   host: 'pdf.jotta.us',
// }
// const config = {
//   scheme: 'http',
//   host: 'localhost',
// }

export const pdfHost = config.host

export function PdfView({ url }: { url: string }) {
  return (
    <iframe
      title="PDF viewer"
      // PDF.js needs same-origin + scripts; oxlint flags this combo as a sandbox escape risk.
      // oxlint-disable-next-line react/iframe-missing-sandbox
      sandbox="allow-scripts allow-same-origin allow-downloads allow-modals"
      className={'absolute bottom-0 left-0 right-0 top-0 size-full'}
      src={`${config.scheme}://${pdfHost}/web/viewer.html?file=${encodeURIComponent(url)}`}
      width="100%"
      height="100%"
    />
  )
}
